// extracted by mini-css-extract-plugin
export default {"adviseFrameContainer":"AdViseFrame_adviseFrameContainer__P608u"};